var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6826 17C29.2349 17 29.6826 16.5523 29.6826 16C29.6826 15.4477 29.2349 15 28.6826 15V17ZM4.68262 15C4.13033 15 3.68262 15.4477 3.68262 16C3.68262 16.5523 4.13033 17 4.68262 17L4.68262 15ZM28.6826 15L4.68262 15L4.68262 17L28.6826 17V15Z",
    fill: "#6D7079"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6422 23.3737C11.0327 23.7642 11.6659 23.7642 12.0564 23.3737C12.4469 22.9832 12.4469 22.35 12.0564 21.9595L10.6422 23.3737ZM4.68262 15.9999L3.97551 15.2928C3.58499 15.6833 3.58499 16.3165 3.97551 16.707L4.68262 15.9999ZM12.0564 10.0404C12.4469 9.64983 12.4469 9.01667 12.0564 8.62615C11.6659 8.23562 11.0327 8.23562 10.6422 8.62615L12.0564 10.0404ZM12.0564 21.9595L5.38972 15.2928L3.97551 16.707L10.6422 23.3737L12.0564 21.9595ZM5.38972 16.707L12.0564 10.0404L10.6422 8.62615L3.97551 15.2928L5.38972 16.707Z",
    fill: "#6D7079"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalBackArrow);
export default __webpack_public_path__ + "static/media/modal-back-arrow.9af9e597a6b969f49468e5e1c002f834.svg";
export { ForwardRef as ReactComponent };